import { Box, CircularProgress } from "@mui/material";
import React from "react";

const DefaultLoader = () => {
	return (
		<Box
			sx={{
				height: "100vh",
				width: "100vw",
				zIndex: 9999,
				background: "rgba(0,0,0,0.2)",
				position: "fixed",
				top: 0,
				left: 0,
				overflow: "hidden", // Prevent scrolling
				pointerEvents: "none", // Disable clicking
			}}>
			<Box
				sx={{
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					height: "100%",
					width: "100%",
					pointerEvents: "auto", // Allow pointer events on the loader itself
				}}>
				<CircularProgress />
			</Box>
		</Box>
	);
};

export default DefaultLoader;
